<template>
  <section class="section-chechout" id="menu-section" v-if="newCart" v-loading.fullscreen.lock="processing"
    element-loading-background="rgba(256, 256, 256, 0.6)">
    <component :is="'style'">
      .text{ background-color:{{ myTheme.topMenu.normal.backgroundColor }};
      color:{{ myTheme.topMenu.normal.color }}; } .active-selected-card{
      color:{{ myTheme.topMenu.normal.backgroundColor }}; font-size:20px }
    </component>
    <div class="container">
      <div class="row">
        <div class="col-md-6 ml-auto col-xl-6 mr-auto">
          <b-alert v-model="showEmailAlert" variant="danger" dismissible>{{
            this.emailExist
          }}</b-alert>
          <cards>
            <tabs :itemStyle="myTheme.customizeButton" class="checkout-tabs" slot="raw-content"
              tab-content-classes="tab-content-padding" v-model="orderCompleted.step">
              <tab-pane :disabled="orderCompleted.step > STEPS.STEP02" label="Step01">
                <div slot="label" class="text-center">
                  <i class="now-ui-icons k-icon-account"></i>
                  {{ $t("text.step_01") }}
                </div>
                <div class="section-steps-1">
                  <div class="container">
                    <div class="row">
                      <cards class="card-step1" header-classes="text-center">
                        <template slot="header">
                          <div class="social-line"></div>
                        </template>
                        <template>
                          <div class="form-group input-group" v-if="!isAuthenticated">
                            <p class="p-login">
                              {{ $t("text.already_have_an_account") }}
                              <router-link class="url-color" to="/login?redirect=checkout">{{ $t("text.login_here")
                              }}</router-link>
                            </p>
                          </div>
                          <fg-input :disabled="isAuthenticated && user.first_name" class="no-border" :class="{
                            'has-danger': errors.firstName,
                            'has-success': errors.firstName === false,
                          }" :placeholder="$t('input.placeholder.first_name')"
                            addon-left-icon="now-ui-icons users_circle-08"
                            v-model.lazy="newCart.user.first_name"
                            @input="checkInputValue(newCart.user.first_name, 'firstName')"
                            ></fg-input>

                          <fg-input :disabled="isAuthenticated && user.last_name" class="no-border" :class="{
                            'has-danger': errors.lastName,
                            'has-success': errors.lastName === false,
                          }" :placeholder="$t('input.placeholder.last_name')"
                            addon-left-icon="now-ui-icons text_caps-small"
                            v-model.lazy="newCart.user.last_name"
                            @input="checkInputValue(newCart.user.last_name, 'lastName')"
                            ></fg-input>

                          <fg-input :disabled="isAuthenticated && user.email" class="no-border" :class="{
                            'has-danger': errors.email,
                            'has-success': errors.email === false,
                          }" :placeholder="$t('input.placeholder.email')" addon-left-icon="now-ui-icons ui-1_email-85"
                            v-model.lazy="newCart.user.email"
                            @input="checkInputValue(newCart.user.email, 'email')"
                            ></fg-input>
                            <ValidationProvider rules="numeric|required" v-slot="{}" ref="phoneValidator">
                              <fg-input type="tel" :disabled="isAuthenticated && user.telephone_number" class="no-border" :class="{
                                'has-danger': errors.phoneNumber,
                                'has-success': errors.phoneNumber === false,
                              }" :placeholder="$t('input.placeholder.contact_number')"
                                addon-left-icon="now-ui-icons k-icon-phone"
                                v-model.lazy="newCart.user.telephone_number" @input="checkInputValue(newCart.user.telephone_number, 'phoneNumber')"></fg-input>
                          </ValidationProvider>
                          <!---------------Start Table Selection---------------->
                          <div v-if="newCart.orderType == ORDER_TYPE.Table.id"
                            class="table-ordering form-group input-group">
                            <template>
                              <el-select v-model="table_id" :class="{
                                'has-danger': errors.table,
                                'has-success': errors.table === false,
                              }" :placeholder="$t('input.placeholder.select_table')" @change="OnTableChanged">
                                <el-option v-for="(
                                                              table, index
                                                            ) in selectedLocation.tables" :key="index"
                                  :label="table.name" :value="table.id">
                                  <span style="float: left">
                                    {{ table.name }}
                                  </span>
                                  <span style="float: right;color: #8492a6;font-size: 13px;">{{ $t("text.capacity") }} :
                                    {{ table.capacity }}</span>
                                </el-option>
                              </el-select>
                            </template>
                          </div>
                          <!---------------End Table Selection---------------->

                          <!---------------Start Coupon Status---------------->
                          <div class="form-group input-group" v-if="isAuthenticated && couponStatus">
                            <el-alert :title="couponStatus.title" :type="couponStatus.type" :closable="false"></el-alert>
                          </div>
                          <!---------------End Coupon Status---------------->
                          <!---------------Start pickupTime--------------->
                          <div class="pickup-delivery" v-if="newCart.orderType != ORDER_TYPE.Table.id">
                            <div class="list-group-item">
                              <p class="title">
                                <span>
                                  {{
                                    newCart.orderType ==
                                    ORDER_TYPE.Delivery.id
                                    ? $t("text.delivery")
                                    : newCart.orderType ==
                                      ORDER_TYPE.Collection.id
                                      ? $t("text.collection")
                                      : ""
                                  }}
                                  {{ $t("text.time") }}
                                </span>
                              </p>
                              <div class="btn-group">
                                <n-radio-button v-if="displayASAPButton" :styleClass="myTheme.standardRadioButton"
                                  v-model="newCart.pickUp.type" :label="PiCKUP_TIME.ASAP" v-on:input="OnTimeTypeChanged">
                                  {{
                                    $t("text.asap_estimation", {
                                      value: getOrderSettingsByType()
                                        .deliveryPickupTime,
                                    })
                                  }}</n-radio-button>
                                <n-radio-button :styleClass="myTheme.standardRadioButton" v-model="newCart.pickUp.type"
                                  :label="PiCKUP_TIME.LATER" v-on:input="OnTimeTypeChanged">{{ $t("text.later")
                                  }}</n-radio-button>
                              </div>
                              <div class="datepicker-container" v-if="
                                newCart.pickUp.type ==
                                PiCKUP_TIME.LATER
                              ">
                                <div class="row">
                                  <div class="col-md-6">
                                    <fg-input inputClasses="select-read-only" class="no-border" :class="{
                                      'has-danger': errors.date,
                                      'has-success': errors.date === false,
                                    }">
                                      <el-date-picker type="date" :clearable="false" :picker-options="datePickerOptions"
                                        popper-class="date-picker date-picker-primary" :placeholder="
                                          $t('input.placeholder.select_date')
                                        " v-model="newCart.pickUp.date" value-format="yyyy-MM-dd"
                                        @change="onDateChanged"></el-date-picker>
                                    </fg-input>
                                  </div>
                                  <div class="col-md-6">
                                    <fg-input class="no-border" :class="{
                                      'has-danger': errors.time,
                                      'has-success': errors.time === false,
                                    }">
                                      <el-select v-model="newCart.pickUp.time" :placeholder="
                                        $t('input.placeholder.select_time')"  @change='onTimeChanged'>
                                        <el-option v-for="(time, index) in timeOptions" :key="index" :label="time.name"
                                          :value="time.name">{{ time.name }}</el-option>
                                      </el-select>
                                    </fg-input>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group input-group">
                            <div v-if="
                              newCart.pickUp.type ==
                              PiCKUP_TIME.LATER &&
                              newCart.pickUp.date &&
                              newCart.pickUp.time
                            ">
                              <span class="title">{{ $t("text.time") }} :</span>
                              <span>{{ getDateTimeText(newCart.pickUp) }}</span>
                            </div>
                          </div>
                          <!---------------End pickupTime--------------->
                          <!--------------- Start Display the delivery details : Select option for user , Adress input for guests--------------->
                          <div class="pickup-delivery" v-if="
                            newCart.orderType == ORDER_TYPE.Delivery.id
                          ">
                            <p class="title">
                              {{ $t("text.delivery_details") }}
                            </p>
                            <div v-if="isAuthenticated" class="form-group no-border">
                              <div class="input-group">
                                <div class="
                                                              col-md-8
                                                              romove-left-right-padding
                                                              add-top-margin
                                                            ">
                                  <el-select v-model="address_id" :placeholder="
                                    $t('input.placeholder.Select_address')
                                  " @change="OnAddressChanged">
                                    <el-option v-for="(address, index) in user.addresses" :key="index" :label="
                                      address.name || address.address_line_1
                                    " :value="address.id">
                                      <span class="span-left" style="white-space: nowrap !important">
                                        {{
                                          address.name || address.address_line_1
                                        }}
                                      </span>
                                      <span class="span-right">
                                        {{
                                          generateFromatedAddress(
                                            address,
                                            false
                                          )
                                        }}
                                      </span>
                                    </el-option>
                                  </el-select>
                                </div>
                                <div class="col-md-4 romove-left-right-padding">
                                  <n-button :style="myTheme.customizeButton" type="primary" @click="onAddNewAddress" round
                                    block>{{ $t("button.new_address") }}</n-button>
                                </div>
                              </div>
                              <div class="required form-group input-group" v-if="errors.address === true">
                                {{ $t("text.please_select_address") }}
                              </div>
                            </div>
                            <div v-else class="form-group no-border">
                              <address-lookup-form :isNewAddress="isNewAddress" :address="addressToEditData"
                                @updateAddress="setCartAddress" :placeholderText="
                                  this.$t('input.placeholder.start_typing')
                                " />
                            </div>
                            <div class="form-group" v-if="deliverFeeStatus">
                              <el-alert :title="deliverFeeStatus.title" :type="deliverFeeStatus.type"
                                :closable="false"></el-alert>
                            </div>
                          </div>
                          <!--------------- Start driver Instructions --------------->
                          <fg-textarea v-if="
                            newCart.orderType === ORDER_TYPE.Delivery.id
                          " class="no-border" maxlength="500" :placeholder="
  $t('input.placeholder.driver_instruction')
" addon-left-icon="now-ui-icons ui-1_email-85" v-model.lazy="newCart.driver_instructions"></fg-textarea>
                          <!--------------- End driver Instructions --------------->
                          <!--------------- Start comment --------------->
                          <fg-textarea class="no-border" maxlength="500" :placeholder="
                            $t('input.placeholder.your_comment_opt')
                          " addon-left-icon="now-ui-icons ui-1_email-85" v-model.lazy="newCart.comment"></fg-textarea>
                          <!--------------- End comment --------------->
                          <!--------------- Start Agreement --------------->
                          <div class="form-group input-group">
                            <p class="agreement">
                              {{ $t("text.terms_conditions_1") }}
                              <strong>
                                <router-link class="url-color" to="/termsandconditions">{{ $t("text.terms_conditions_2")
                                }}
                                </router-link>
                              </strong>
                              {{ $t("text.terms_conditions_3") }}
                            </p>
                            <n-checkbox v-model="isAgree" style="width: 100%">Agree</n-checkbox>
                            <p class="required" v-if="errors.agree === true && !isAgree">
                              {{ $t("validation.agree_required") }}
                            </p>
                          </div>
                          <!--------------- End Agreement --------------->
                        </template>
                      </cards>
                    </div>
                  </div>
                </div>
              </tab-pane>
              <tab-pane :disabled="orderCompleted.step != STEPS.STEP02" label="Step02">
                <template slot="label">
                  <i class="now-ui-icons shopping_cart-simple"></i>
                  {{ $t("text.step_02") }}
                </template>
                <div class="section-steps-2">
                  <div class="container">
                    <div class="row">
                      <cards class="card-step2" header-classes="text-center">
                        <template slot="header">
                          <div class="social-line"></div>
                        </template>
                        <template>
                          <!---------------Start payment---------------->
                          <div class="mode-payment p-1">
                            <div class="list-group-item
                                                          d-flex
                                                          justify-content-center
                                                        ">
                              <div class="
                                                            payment-type
                                                            clickable
                                                            d-flex
                                                            justify-content-center
                                                            align-items-center
                                                            mx-1
                                                          " v-for="(mode, index) in availablePaymentMode" :key="index"
                                @click="OnPayementTypeChanged(mode.type)">
                                <div v-if="newCart.payment_type == mode.type" class="
                                                              d-flex
                                                              flex-column
                                                              justify-content-center
                                                              align-items-center
                                                            ">
                                  <span class="p-0 m-0 w-100 text-center">{{
                                    mode.label
                                  }}</span>
                                  <i class="
                                                                k-icon-ok-circled
                                                                text-success
                                                                active
                                                              "></i>
                                </div>
                                <div v-else class="availale-mode">
                                  <div class="icon">
                                    <el-image :src="mode.icon" />
                                  </div>
                                  <div class="text">
                                    {{ mode.label }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="required" v-if="errors.payment_type === true">
                              {{ $t("text.please_select_payment_mode") }}
                            </div>
                          </div>

                          <div class="py-4" v-if="
                            newCart.payment_type >= PAYMENT_TYPE.Card
                          ">
                            <div class="row">
                              <div class="col-md-12 col-md-12 text-center">
                                <img src="img/stripenomobilepay.svg" class="stripeImg" alt="Image" />
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-12 col-md-12 text-center">
                                <div v-if="
                                  newCart.payment_type ==
                                  PAYMENT_TYPE.ApplePay
                                ">
                                  <img src="img/apple-payment-mode.svg" class="apple-pay-img" alt="Image" />
                                </div>
                                <div v-else-if="
                                  newCart.payment_type ==
                                  PAYMENT_TYPE.GooglePay
                                ">
                                  <img src="img/google-payment-mode.svg" class="google-pay-img" alt="Image" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="stripe-wrapper" v-show="
                            newCart.payment_type == PAYMENT_TYPE.Card
                          ">
                            <!---------------Start Card Selection ---------------->
                            <div class="form-group input-group" v-if="isAuthenticated">
                              <el-select v-if="userCards && userCards.length" @change="OnCardSelection" v-model="card_id"
                                :placeholder="
                                  selectedCard
                                    ? ''
                                    : $t('input.placeholder.select_card')
                                " :class="{
  'has-danger': errors.card_id,
  'has-success': errors.card_id === false,
}">
                                <el-option class="clear-selection" v-if="card_id > 0" label="Clear Selection"
                                  value="-1"></el-option>
                                <el-option :disabled="
                                  disableExpiredCard(item.stripe_object)
                                " v-for="(item, index) in userCards" :key="index" :value="item.id">
                                  <div class="card-option media float-left" v-if="item.stripe_object">
                                    <div class="card-icon mr-2">
                                      <el-image :src="
                                        getCardBrandIcon(item.stripe_object)
                                      " />
                                    </div>
                                    <div class="media-body card-text">
                                      {{
                                        getCardNumberWithStars(
                                          item.stripe_object.last4
                                        )
                                      }}
                                    </div>
                                  </div>
                                  <div class="card-text float-right" style="color: #8492a6" v-if="item.stripe_object">
                                    <span v-if="card_id != item.id">{{ textExpiredCard(item.stripe_object) }}
                                    </span>
                                    <i v-else class="
                                                                  k-icon-ok-circled
                                                                  active-selected-card
                                                                "></i>
                                  </div>
                                </el-option>
                                <template v-if="selectedCard" #prefix>
                                  <div class="card-option media float-left w-100">
                                    <div class="card-icon mr-2">
                                      <el-image :src="
                                        getCardBrandIcon(
                                          selectedCard.stripe_object
                                        )
                                      " />
                                    </div>
                                    <div class="media-body card-text">
                                      {{
                                        getCardNumberWithStars(
                                          selectedCard.stripe_object.last4
                                        )
                                      }}
                                    </div>
                                    <div class="card-text float-right">
                                      <i class="
                                                                    k-icon-ok-circled
                                                                    active-selected-card
                                                                  "></i>
                                    </div>
                                  </div>
                                </template>
                              </el-select>
                            </div>
                            <!---------------End Card Selection ---------------->
                            <!---------------Start Stripe Card ---------------->
                            <div class="form-group input-group" v-if="
                              stripeIsMounted &&
                              card_id == null &&
                              newCart.payment_type == PAYMENT_TYPE.Card
                            ">
                              <card ref="newCard" class="form-control stripe-card" :class="{ complete }"
                                :stripe="stripeKey" :options="stripeOptions" :stripe-options="{
                                  apiVersion: getStripeApiVersion(),
                                }" @change="OnCardChange" />
                            </div>
                            <!------------ Will be displayed , if the user don't select a card  in first Step : depend if is user or guest--------------------->
                            <div class="required form-group input-group" v-if="errors.payment_mode === true">
                              {{
                                isAuthenticated
                                ? $t("text.select_pre_saved_card")
                                : $t("text.please_provide_card_to_continue")
                              }}
                            </div>
                            <!---------------End Stripe Card ---------------->
                            <!---------------End payment---------------->
                            <!-------------- Propose to the guest to connect ------------------>
                            <div class="form-group input-group" v-if="!isAuthenticated">
                              <n-button type="primary" @click="redirectToLogin" :style="myTheme.customizeButton">{{
                                $t("text.login_to_save_card") }}</n-button>
                            </div>
                            <!--------------- Propose to Save the new Introduced card --------------->
                            <div v-else-if="
                              card_id == null &&
                              newCart.payment_type == PAYMENT_TYPE.Card
                            " class="form-group input-group">
                              <n-checkbox v-model="newCart.save_card" style="width: 100%" :disabled="disableSaveCard">{{
                                $t("text.save_card_for_next_use")
                              }}</n-checkbox>
                            </div>
                            <!--------------- Propose to Save the new Introduced card --------------->
                          </div>
                          <!---------------End payment---------------->
                        </template>
                      </cards>
                    </div>
                  </div>
                </div>
              </tab-pane>
              <tab-pane :disabled="
                orderCompleted &&
                orderCompleted.step <= STEPS.STEP03
              " label="Step03">
                <template slot="label">
                  <i class="now-ui-icons shopping_shop"></i>
                  {{ $t("text.step_03") }}
                </template>
                <div class="section-steps-3" v-if="orderCompleted">
                  <div class="container">
                    <div class="row">
                      <sweetalert-icon :icon="notificationType" />
                      <cards class="menu-card mb-3">
                        <div class="list-group-item">
                          {{
                            $t("text.step_3_desc", {
                              orderId: orderCompleted.id,
                            })
                          }}
                        </div>
                      </cards>
                      <n-button :disabled="loadTracking" :style="myTheme.registrationButtons" type="primary"
                        v-if="orderCompleted" @click="displayOrderTrack" round block class="mb-4">
                        <i v-if="loadTracking" class="k-icon-spin4 animate-spin"></i>
                        {{ $t("button.track_order_progress") }}</n-button>
                      <cards class="menu-card">
                        <div class="list-group-item">
                          <ul class="list-group list-group-flush">
                            <li class="list-group-item" v-if="orderCompleted && orderCompleted.user">
                              <strong>{{ $t("text.customer_name") }}:</strong>
                              {{
                                orderCompleted.user.first_name +
                                " " +
                                orderCompleted.user.last_name
                              }}
                            </li>
                            <li class="list-group-item">
                              <strong>{{ $t("text.contact_number") }} :</strong>
                              {{ orderCompleted.user.telephone_number }}
                            </li>
                            <li class="list-group-item">
                              <strong>{{ $t("text.order_type") }} :</strong>
                              {{
                                getOrderTypeText(
                                  orderCompleted.orderType
                                )
                              }}
                            </li>
                            <li class="list-group-item" v-if="
                              orderCompleted.orderType ===
                              ORDER_TYPE.Delivery.id
                            ">
                              <strong>{{ $t("text.delivery_address") }} :</strong>
                              {{
                                generateFromatedAddress(
                                  orderCompleted.address
                                )
                              }}
                            </li>
                            <li class="list-group-item">
                              <strong>{{ $t("text.time") }} :</strong>
                              {{ getDateTimeText(orderCompleted.pickUp) }}
                            </li>
                            <li class="list-group-item">
                              <strong>{{ $t("text.payment_method") }}:</strong>
                              {{
                                orderCompleted.payment_type ==
                                PAYMENT_TYPE.Cash
                                ? $t("text.cash_payment")
                                : $t("text.card_payment")
                              }}
                            </li>
                          </ul>
                        </div>
                      </cards>
                      <p>{{ $t("text.your_order") }} :</p>
                      <cards class="menu-card" v-for="( orderItem, index) in orderCompleted.order" :key="index">
                        <div class="wrapper-menu-Item"
                          v-html="completedOrderItemCardFormatter(orderItem, myTheme, orderCompleted.orderType)"></div>
                        <!--div class="wrapper-menu-Item">
                          <div class="box favorite">
                            <i
                              class="new-ui-icons"
                              :class="{
                                'k-icon-tab-favourites fav': item.is_favourite,
                                'k-icon-heart-line': !item.is_favourite,
                              }"
                            ></i>
                          </div>
                          <div class="box details">
                            <p
                              class="title"
                              :style="{ color: myTheme.primaryTextColor }"
                            >
                              {{ item.name }}
                            </p>

                            <div class="options-item">
                              <div v-if="item.options && item.options.length">
                                <div
                                  v-for="(option, index) in item.options"
                                  :key="index"
                                >
                                  <div
                                    v-if="
                                      option.type === 'RADIO' ||
                                      option.type === 'SELECT'
                                    "
                                  >
                                    <div
                                      class="options-item-grid"
                                      v-for="(value, index) in option.values"
                                      :key="index"
                                    >
                                      <div
                                        v-if="value.id == option.selected_items"
                                        class="option-name"
                                      >
                                        ++ {{ value.name }}
                                      </div>
                                    </div>
                                  </div>
                                  <div v-if="option.type === 'CHECKBOX'">
                                    <div
                                      class="options-item-grid"
                                      v-for="(
                                        idValue, index
                                      ) in option.selected_items"
                                      :key="index"
                                    >
                                      <div v-if="idValue" class="option-name">
                                        ++
                                        {{
                                          getValueName(
                                            option.values,
                                            idValue
                                          )
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="options-comment" v-if="item.comment">
                              [{{ item.comment }}]
                            </div>
                            <div
                              class="d-inline dietry-requirements"
                              v-for="(
                                dieatry, index
                              ) in getMenuItemDieatriesIcons(item)"
                              :key="index"
                            >
                              <i
                                class="new-ui-icons mr-1"
                                :class="dieatry.icon"
                                :title="dieatry.name"
                              ></i>
                            </div>
                          </div>
                          <div class="box price text-center my-auto">
                            {{
                              getMenuItemTotal(item, orderCompleted.orderType)
                                | currency(currentCurrency)
                            }}
                          </div>
                          <div class="box counter text-center my-auto">
                            <span>{{ item.quantity }}x</span>
                          </div>
                        </!--div-->
                      </cards>
                      <div class="grid-payment">
                        <div class="grid-label">
                          {{ $t("text.sub_total") }} :
                        </div>
                        <div class="grid-value">
                          {{ orderCompleted.total | currency(currentCurrency) }}
                        </div>
                        <div class="grid-label">
                          {{ $t("text.service_charges") }} :
                        </div>
                        <div class="grid-value">
                          {{
                            orderCompleted.service_charge
                            | currency(currentCurrency)
                          }}
                        </div>
                        <div class="grid-label" v-if="
                          orderCompleted.bag_charge &&
                          orderCompleted.bag_charge != '0.00'
                        ">
                          {{ $t("text.bag_charge") }} :
                        </div>
                        <div class="grid-value" v-if="
                          orderCompleted.bag_charge &&
                          orderCompleted.bag_charge != '0.00'
                        ">
                          {{
                            orderCompleted.bag_charge
                            | currency(currentCurrency)
                          }}
                        </div>
                        <div class="grid-label red" v-if="
                          orderCompleted.orderType ==
                          ORDER_TYPE.Delivery.id
                        ">
                          {{ $t("text.delivery_fee") }} :
                        </div>
                        <div class="grid-value red" v-if="
                          orderCompleted.orderType ==
                          ORDER_TYPE.Delivery.id
                        ">
                          {{
                            orderCompleted.delivery_fee
                            | currency(currentCurrency)
                          }}
                        </div>
                        <div class="grid-label green" v-if="orderCompleted.coupon_result">
                          {{ $t("text.discount") }} :
                        </div>
                        <div class="grid-value green" v-if="orderCompleted.coupon_result">
                          {{
                            orderCompleted.coupon_result.discountAmount
                            | currency(currentCurrency)
                          }}
                        </div>
                        <div class="grid-label order-total">
                          {{ $t("text.order_total") }} :
                        </div>
                        <div class="grid-value order-total">
                          {{
                            orderCompleted.orderTotal
                            | currency(currentCurrency)
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </tab-pane>
            </tabs>
          </cards>
          <!--------------- Start Generate payment Buttons ---------------->
          <div class="send-button">
            <b-alert v-model="showEmailAlert" variant="danger" dismissible>{{
              this.emailExist
            }}</b-alert>
            <div v-if="displayNativeApplePayButton" @click="startNativePay" class="
                                          apple-pay-button-with-text apple-pay-button-black-with-text
                                        ">
              <span class="text">Buy with</span>
              <span class="logo"></span>
            </div>
            <div v-else-if="displayApplePayButton" @click="paymentRequestResult.show()" class="
                                          apple-pay-button-with-text apple-pay-button-black-with-text
                                        ">
              <span class="text">Buy with</span>
              <span class="logo"></span>
            </div>
            <!--div
              v-else-if="displayNativeGooglePayButton"
              class="button-google-pay"
              @click="startNativePay"
            ></!--div-->
            <div v-else-if="displayGooglePayButton" class="button-google-pay" @click="paymentRequestResult.show()"></div>
            <n-button :style="myTheme.customizeButton" type="primary" v-else-if="displayPayButton" :disabled="
              processing ||
              disable ||
              !newCart ||
              !newCart.order ||
              !newCart.order.length
            " @click="onProcessOrder" round block>{{ buttonTitle }}</n-button>
          </div>
          <!---------------Start Generate payment Buttons ---------------->
          <div class="back-to-menu-link mt-3">
            <a href="#" @click="goToMenu" class="url-color" v-if="orderCompleted.step <= STEPS.STEP02">
              <p>{{ $t("button.back_to_menu") }}</p>
            </a>
            <router-link to="/" class="url-color" v-else>
              <p>{{ $t("button.back_to_home") }}</p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <modal :ignoreBackdropClick="true" @close="modalClosed" :show.sync="show" headerClasses="justify-content-center"
      class="modal-options" modalClasses="modal-dialog-centered modal-dialog-scrollable">
      <h4 slot="header" class="title title-up">
        {{
          isNewAddress ? $t("text.add_new_address") : $t("text.edit_address")
        }}
      </h4>
      <add-address :fromModal="true" :isNewAddress="isNewAddress" @exit="onCloseModal"
        :address="addressToEditData"></add-address>
    </modal>
    <order-view-status-modal ref="itemStatusModal" :order="objOrderHistory"></order-view-status-modal>
  </section>
</template>

<script>
import { cartManager } from "@/utilities";
import { STEPS, PAYMENT_TYPE, STEP_STATUS, ORDER_TYPE, PiCKUP_TIME } from "@/utilities/enums";
import { ValidationProvider } from "vee-validate";
import {
  getMenuItemTotal,
  generateFromatedAddress,
  validLastOrderDateTime,
  canMakeOrder,
  pad2,
  showErrorMessageAlert,
  controlAvailibilityBeforeCheckout,
  checkOrderItemsAvailibilityForToday,
  checkRequiredAllRequiredItems,
  showMessageConfirmation,
  geMessageByStripeErrorCode,
  getMessageFromAPIError,
  evaluateValue,
  checkDeliveryAvailibality,
  roundTimeQuarterHour,
  getQuarterOrderTimesFromPeriod,
  generateFormatedDateTime,
  getCardBrandIcon,
  getCardNumberWithStars,
  getStripeApiVersion,
  getOrderTypeText,
  getValueName,
  getMenuItemDieatriesIcons,
  completedOrderItemCardFormatter,
  getAllSelectedOrderItems
} from "@/utilities/helper";
import { mapState, mapActions } from "vuex";
import router from "@/router";

import {
  Cards,
  Tabs,
  TabPane,
  Button,
  FormGroupInput,
  FormTexterea,
  Checkbox,
  RadioButton,
  Radio,
  Modal,
} from "@/components";
import { AddressLookupForm, AddAddress } from "@/views/components";
import { OrderViewStatusModal } from "@/views/modals";
import Vue2Filters from "vue2-filters";
import objectAddress from "@/model/address";
import { Card } from "vue-stripe-elements-plus-sa";
import { onMesssageMixin, paymentMixin, couponMixin, orderingMixin } from "@/mixins";


export default {
  name: "checkout",
  mixins: [Vue2Filters.mixin, onMesssageMixin, paymentMixin, couponMixin, orderingMixin],
  components: {
    [Radio.name]: Radio,
    Cards,
    Tabs,
    TabPane,
    [Button.name]: Button,
    [RadioButton.name]: RadioButton,
    [FormGroupInput.name]: FormGroupInput,
    [FormTexterea.name]: FormTexterea,
    [Checkbox.name]: Checkbox,
    Modal,
    AddAddress,
    AddressLookupForm,
    Card,
    OrderViewStatusModal,
    ValidationProvider

  },
  computed: {
    couponStatus() {
      if (!this.newCart) return null;
      if (this.newCart.coupon_result) {
        return {
          title: this.$t("message.discount_msg_status", {
            discount: this.$options.filters.currency(
              this.newCart.coupon_result.discountAmount
            ),
          }),
          type: "success",
        };
      }
      return null;
      /*else if (this.newCart.coupon_error) {
        return {
          title:
            this.newCart.coupon_error.error && this.newCart.coupon_error.error.message
              ? this.newCart.coupon_error.error.message
              : "the coupon code " + this.newCart.coupon + " is no longer valid",
          type: "error",
        };
      }
      return {
        title: "",
        type: "",
      };*/
    },
    ...mapState('cartStore', ['orderTotal']),
    ...mapState('userStore', ['userCards', "guestData"]),
    buttonTitle() {
      if (this.newCart.step == STEPS.STEP02) {
        if (this.newCart.payment_type == PAYMENT_TYPE.Cash)
          return this.$t("button.place_order_for", {
            total_price: this.$options.filters.currency(this.orderTotal),
          });
        return this.$t("button.pay", {
          total_price: this.$options.filters.currency(this.orderTotal),
        });
      }
      return this.$t("button.payment");
    },
    locationStatus: function () {
      return canMakeOrder(this.selectedLocation);
    },
    notificationType() {
      if (this.orderCompleted.status == STEP_STATUS.COMPLETED)
        return "success";
      else return "error";
    },
    orderCompleted() {
      return JSON.parse(localStorage.getItem("saved-order")) || this.newCart;
    },
    displayNativeApplePayButton() {
      return (
        this.newCart.step == STEPS.STEP02 &&
        this.newCart.payment_type == PAYMENT_TYPE.ApplePay &&
        this.getNativeApplePayStatus
      );
    },
    displayNativeGooglePayButton() {
      return false;
      //-- TODO : Enable when Native Google Pay is working
      /*return (
        this.newCart.step == STEPS.STEP02 &&
        this.newCart.payment_type == PAYMENT_TYPE.GooglePay &&
        this.getNativeGooglePayStatus
      );*/
    },
    displayApplePayButton() {
      return (
        this.newCart.step == STEPS.STEP02 &&
        this.canMakePayment &&
        this.canMakePayment.applePay &&
        this.newCart.payment_type == PAYMENT_TYPE.ApplePay
      );
    },
    displayGooglePayButton() {
      return (
        this.newCart.step == STEPS.STEP02 &&
        this.canMakePayment &&
        this.canMakePayment.googlePay &&
        this.newCart.payment_type == PAYMENT_TYPE.GooglePay
      );
    },
    displayPayButton() {
      return (
        this.orderCompleted.step == STEPS.STEP01 ||
        this.orderCompleted.step == STEPS.STEP02
      );
    },
    displayASAPButton() {
      return (
        this.selectedLocation &&
        ((this.newCart.orderType == ORDER_TYPE.Delivery.id &&
          this.selectedLocation.openingHours.delivery) ||
          (this.newCart.orderType == ORDER_TYPE.Collection.id &&
            this.selectedLocation.openingHours.collection) ||
          (this.newCart.orderType == ORDER_TYPE.Table.id &&
            this.selectedLocation.openingHours.sitIn))
      );
    },
    disableExpiredCard() {
      return (cardDetails) => {
        return this.isCardExpired(cardDetails);
      };
    },
    textExpiredCard() {
      return (cardDetails) => {
        return this.isCardExpired(cardDetails)
          ? `${this.$t("text.expired_on", {
            month_year: `${pad2(cardDetails.exp_month)}/${cardDetails.exp_year
              }`,
          })}`
          : `${this.$t("text.expires_on", {
            month_year: `${pad2(cardDetails.exp_month)}/${cardDetails.exp_year
              }`,
          })}`;
      };
    },
    selectedCard() {
      return this.card_id > 0
        ? this.userCards.find((x) => x.id == this.card_id)
        : null;
    }
  },
  data() {
    return {
      completedOrderItemCardFormatter,
      getMenuItemDieatriesIcons,
      getValueName,
      getOrderTypeText,
      getStripeApiVersion,
      getCardNumberWithStars,
      getCardBrandIcon,
      getMenuItemTotal,
      generateFromatedAddress,
      ORDER_TYPE,
      PAYMENT_TYPE,
      STEPS,
      PiCKUP_TIME,
      showEmailAlert: false,
      isNewAddress: true,
      disableSaveCard: true, // disable/enable save card checbox
      errors: {
        firstName: null,
        lastName: null,
        email: null,
        phoneNumber: null,
        date: null,
        time: null,
        payment_type: null,
        agree: null,
        payment_mode: null,
      },
      emailExist: null,
      datePickerOptions: {
        disabledDate: this.disabledDatePickerDates,
      },
      timeOptions: [],
      addressToEditData: Object.assign({}, objectAddress),
      address_id: null,
      card_id: null,
      table_id: null,
      complete: false,
      isAgree: false,
      disable: false,
      success: false,
      show: false, // used to show the add new address modal
      laterDateTimeSettings: null,
      currentUser: null,
      isMounted: false,
      deliverFeeStatus: null,
      objOrderHistory: null,
      processing: false,
      loadTracking: false,
    };
  },
  methods: {
    ...mapActions('locationStore', ["fetchLocation"]),

    //*************************** Start Methods for the inputs ****************************** */
    //--- save / confirm the payment process
    async onProcessOrder() {
      this.processing = true;
      this.emailExist = null;
      this.errors.email = null;
      if (await this.checkUserForm()) {
        this.processing = false;
        return;
      }
      const refreshLocationResponse = await this.refreshLocationData().catch(error => { this.captureException(error) });
      if (!refreshLocationResponse) {
        showErrorMessageAlert(
          this.$t("generic_error.refresh_location_data"),
          null,
          "red",
          "OK"
        );
        this.processing = false;
        return false;
      }

      if (!validLastOrderDateTime(this.selectedLocation, this.newCart.orderType, this.newCart.pickUp)) {

        let message = this.$t("message.location_stop_taken_orders", {
          location_name: this.selectedLocation.name,
        });
        if (this.selectedLocation.openingHours.suspended) {
          message = this.$t("message.location_temporary_paused_to", {
            paused_to: this.selectedLocation.paused_to,
          });
        }

        showErrorMessageAlert(
          message,
          null,
          "red",
          this.$t("button.ok")
        ).then(() => {
          this.processing = false;
          this.goToHome();
        });
        return;
      }

      if (controlAvailibilityBeforeCheckout(this.locationStatus, this.newCart)) {
        let message = this.$t("message.location_temporary_closed");
        if (this.selectedLocation.openingHours.suspended) {
          message = this.$t("message.location_temporary_paused_to", {
            paused_to: this.selectedLocation.paused_to,
          });
        }

        showErrorMessageAlert(
          message,
          null,
          "red",
          this.$t("button.ok")
        ).then(() => {
          this.processing = false;
          this.goToHome();
        });

        return;
      }

      //---- if the order is a Re-Order =>  check if the menuItem required options are selected
      const allItems = getAllSelectedOrderItems(this.newCart.order)

      const {menuItems, options, values} = await this.postCheckItemsAvailibilityRequest(allItems);

      if (menuItems?.length || options?.length || values?.length) {

        let message = `${this.$t("message.items_not_available_for_now")} <br>`;
        if (menuItems?.length) {
          message += "<p>Menu Items : </p>";
          message += `<ul class='order-items'>`;
          menuItems.forEach((item) => {
            message += `<li>${item.name}</li>`;
          });
          message += "</ul>";
        }

        if (options?.length) {
          message += "<p>Options : </p>";
          message += `<ul class='order-items'>`;
          options.forEach((item) => {
            message += `<li>${item.name}</li>`;
          });
          message += "</ul>";
        }

        if (values?.length) {
          message += "<p>Choices : </p>";
          message += `<ul class='order-items'>`;
          values.forEach((item) => {
            message += `<li>${item.name}</li>`;
          });
          message += "</ul>";
        }

        showErrorMessageAlert(message,
          null,
          "red",
          this.$t("button.ok")
        );
        //-- Remove the Items
        this.removeItems({ menuItems: menuItems.map(x => x.id), options: options.map(x => x.id), values: values.map(x => x.id), deepRemove: true })
        this.processing = false;
        this.$nextTick(() => {
          this.goToMenu();
        })

        return;
      }

      const itemsAvailibilityForTodayResponse = await checkOrderItemsAvailibilityForToday(this.newCart.order, this.$moment(), this.locationMenuItems);

      if (
        itemsAvailibilityForTodayResponse.today.length ||
        itemsAvailibilityForTodayResponse.now.length
      ) {
        let message = "";
        if (itemsAvailibilityForTodayResponse.today.length) {
          message = `${this.$t(
            "message.items_not_available_for_today"
          )} : <br> <ul class='order-items'>`;
          itemsAvailibilityForTodayResponse.today.forEach((item) => {
            message += `<li>${item.name}</li>`;
          });
          message += "</ul>";
        }
        if (itemsAvailibilityForTodayResponse.now.length) {
          message += `${this.$t(
            "message.items_not_available_for_now"
          )} : <br> <ul class='order-items'>`;
          itemsAvailibilityForTodayResponse.now.forEach((item) => {
            message += `<li>${item.name}</li>`;
          });
          message += "</ul>";
        }

        message += message += `<p class='message'>${this.$t(
          "message.select_another_interval"
        )}</p>`;
        this.processing = false;

        showMessageConfirmation(
          message,
          "k-icon-preptime",
          this.staticColor.orange,
          this.$t("button.continue"),
          this.$t("button.go_to_menu")
        ).then((confirm) => {
          if (!confirm) {
            //--- remove the outdated items
            const itemsId = itemsAvailibilityForTodayResponse.today
              .concat(itemsAvailibilityForTodayResponse.now)
              .map((x) => x.id);
            this.removeItems({ menuItems: itemsId })
            this.$nextTick(() => {
              this.goToMenu();
              return;
            });
          }
        });
      }

      const checkRequiredMenuItemOptionsResponse = await checkRequiredAllRequiredItems(this.newCart.order).catch(response => {

        showErrorMessageAlert(
          response,
          null,
          "red",
          this.$t("button.ok")
        );
      })

      if (!checkRequiredMenuItemOptionsResponse) {
        this.processing = false;
        this.goToMenu();
        return;
      }

      //--- verify the coupon if any is provided | coupon is only availabled for logged users
      if (!this.user || !this.newCart.coupon) {
        this.continuePaymentProcess();
        return
      }

      this.onSubmitCoupon(false, false).then((result) => {
        if (result.valid && !result.auto) {
          //--- the original coupon is valide and the payment process can continue
          this.continuePaymentProcess();
        } else {
          let message = this.$t(
            "message.sorry_coupon_no_longer_valid"
          );

          if (result.valid && result.auto) {
            message += this.$t("message.autocoupon_applied", {
              orderTotal: this.newCart.orderTotal,
            });
          }
          message += this.$t("message.click_to_process_payment");

          this.processing = false;
          showMessageConfirmation(
            message,
            "k-icon-preptime",
            this.staticColor.orange,
            this.$t("button.continue"),
            this.$t("button.go_to_menu")
          ).then((confirm) => {
            if (confirm) {
              this.processing = false;
              this.continuePaymentProcess();
            } else {
              this.goToMenu();
            }
          });
        }
      });


    },
    continuePaymentProcess() {
      switch (this.newCart.step) {
        case STEPS.STEP01: {
          if (
            this.newCart.status == STEP_STATUS.PREPARED ||
            this.newCart.status == STEP_STATUS.SAVED
          ) {
            cartManager
              .generateOrderObject(this.newCart, this.selectedLocation.id)
              .then((response) => {
                if (this.isAuthenticated) this.postOrder(response);
                else this.PostGuestOrder(response);
              })
              .catch((e) => {
                console.log(e)
                //this.captureException(e);
                this.processing = false;
                this.orderFailed(
                  this.$t("generic_error.error_generating_order"),
                  this.$t("button.back_to_checkout")
                );
              });
          }
          break;
        }
        case STEPS.STEP02: {
          //***** Start the payment */
          if (this.newCart.status == STEP_STATUS.SAVED) {
            this.tokenize()
              .then(() => {
                cartManager
                  .generatePaymentObject(this.newCart, this.selectedLocation.id)
                  .then((response) => {
                    if (this.isAuthenticated) this.postPayment(response);
                    else this.PostGuestPayment(response);
                  })
                  .catch((e) => {
                    this.captureException(e);
                    this.orderFailed(
                      this.$t("generic_error.error_generating_payment"),
                      this.$t("button.back_to_checkout")
                    );
                  });
              })
              .catch((e) => {
                this.captureException(e);
                this.orderFailed(
                  geMessageByStripeErrorCode(e),
                  this.$t("button.back_to_checkout")
                );
              });
          }
        }
      }
    },
    //---- Fired on payment type changed :
    OnPayementTypeChanged(value) {
      this.newCart.payment_type = value;
      if (value != PAYMENT_TYPE.Card) {
        this.card_id = null;
        this.newCart.card = null;
        this.newCart.card_id = null;
      }
      cartManager.setCart(this.newCart, false, false);
    },

    //--- to check the stripe card element
    OnCardChange(event) {
      this.complete = event.complete;
      this.disableSaveCard = !this.complete;
      if (this.complete) {
        this.card_id = null;
        this.newCart.card_id = null;
        cartManager.setCart(this.newCart, false, false);
      }
    },
    //---- Fired when the user select a Card from pre-saved cards
    OnCardSelection: function () {
      if (this.card_id > 0) {
        let obj = this.userCards.find((x) => x.id == this.card_id);
        this.newCart.card = obj;
        this.newCart.card_id = this.card_id;
        this.clearCard();
        this.newCart.save_card = false;
        cartManager.setCart(this.newCart, false, false);
      } else {
        // Card cleared
        this.card_id = null;
        this.newCart.card_id = null;
      }
    },

    //---- Fired When Table is selected => To save the select table number/name
    OnTableChanged: function () {
      if (this.table_id) {
        let _table = this.selectedLocation.tables.find(
          (x) => x.id === this.table_id
        );
        this.newCart.table = {
          id: _table.id,
          name: _table.name,
        };
      }
    },
    //---- Fired When address is selected and check the delivery availability.
    OnAddressChanged: function () {
      if (this.address_id) {
        let addressFound = this.user.addresses.find(
          (x) => x.id === this.address_id
        );
        //**** if the address is missing street number => display the address modal to update the address */
        if (!addressFound.street_number) {
          this.addressToEditData = addressFound;
          this.isNewAddress = false;
          this.show = true;
        } else {
          this.newCart.address = addressFound;
          if (this.newCart.address) this.checkTheDeliveryAddess(); //---- check
        }
      }
    },
    onAddNewAddress() {
      this.addressToEditData = Object.assign({}, objectAddress);
      this.isNewAddress = true;
      this.show = true;
    },
    //---- check the guest Address
    setCartAddress(addressData) {
      this.newCart.address = addressData;
      //console.log(this.newCart.address);
      //--- check the delivery to this Address :
      if (this.newCart.address) this.checkTheDeliveryAddess(); //---- check
    },
    OnTimeTypeChanged() {
      if (this.newCart.pickUp.type == PiCKUP_TIME.LATER) {
        this.newCart.pickUp.date = this.newCart.pickUp.date || new Date();
        this.setTimeOption(this.newCart.pickUp.date);
      } else {
        this.newCart.pickUp.date = null;
        this.newCart.pickUp.time = null;
      }
    },
    //---- post the order to the server
    postOrder(data) {
      this.postOrderRequest(data)
        .then((response) => {
          if (response && response.error) {
            this.orderFailed(
              getMessageFromAPIError(response),
              this.$t("button.back_to_checkout")
            );
            return;
          }
          //----- save the api response
          this.newCart.status = STEP_STATUS.SAVED;
          this.newCart.newOrder = response.order;
          this.newCart.id = response.order.id;
          this.newCart.step = STEPS.STEP02;
          cartManager.setCart(this.newCart, false, false);
          this.processing = false;
        })
        .catch((e) => {
          this.captureException(e);
          this.newCart.status = STEP_STATUS.PREPARED;
          this.newCart.step = STEPS.STEP01;
          this.newCart.id = null;
          this.newCart.newOrder = null;
          cartManager.setCart(this.newCart, false, false);
          if (e && e.data) {
            this.orderFailed(
              getMessageFromAPIError(e.data),
              this.$t("button.back_to_checkout")
            );
          } else {
            this.orderFailed(
              "An error occured when saving your order, please try again",
              this.$t("button.back_to_checkout")
            );
          }
        });
    },
    PostGuestOrder(data) {
      this.postGuestOrderRequest(data)
        .then((response) => {
          if (
            response &&
            response.error &&
            (response.error.message === "User exists!" ||
              "User already exists!")
          ) {
            this.emailExist = this.$t("message.email_exist");
            this.errors.email = true;
            this.processing = false;
            return;
          }
          if (response && response.error) {
            this.orderFailed(
              getMessageFromAPIError(response),
              this.$t("button.back_to_checkout")
            );
            return;
          }
          //----- save the api response
          this.newCart.status = STEP_STATUS.SAVED;
          this.newCart.newOrder = response.order;
          this.newCart.id = response.order.id;
          this.newCart.step = STEPS.STEP02;
          cartManager.setCart(this.newCart, false, false);
          this.processing = false;
        })
        .catch((e) => {
          this.captureException(e);
          this.newCart.status = STEP_STATUS.PREPARED;
          this.newCart.step = STEPS.STEP01;
          this.newCart.id = null;
          this.newCart.newOrder = null;
          cartManager.setCart(this.newCart, false, false);
          if (e && e.data) {
            this.orderFailed(
              getMessageFromAPIError(e.data),
              this.$t("button.back_to_checkout")
            );
          } else {
            this.orderFailed(
              this.$t("generic_error.error_saving_order"),
              this.$t("button.back_to_checkout")
            );
          }
        });
    },

    //---- fired when selecting a date
    onDateChanged: function (value) {
      if(value){
        this.$set(this.errors, 'date', null)
      }
      this.newCart.pickUp.time = null;
      this.setTimeOption(value);
    },
    onTimeChanged(value){

      if(value){
        this.$set(this.errors, 'time', null)
      }
    },
    //--- selectet automaticaly the new added address and close the modal
    onCloseModal(result) {
      this.show = result.show;
      this.isNewAddress = false;
      if (result.address) {
        this.address_id = result.address.id;
        this.newCart.address = result.address;

        this.checkTheDeliveryAddess(); //---- check
      }
    },
    modalClosed() {
      if (!this.newCart.address.street_number) {
        this.address_id = null;
        this.newCart.address = objectAddress;
      }
    },
    //*************************** End Methods for the inputs ****************************** */

    //*************************** Start components Methods ****************************** */
    async checkUserForm() {
      if (this.newCart.step == STEPS.STEP01) {
        this.errors.firstName = !this.newCart.user.first_name; //!
        this.errors.lastName = !this.newCart.user.last_name;
        this.errors.email = !this.newCart.user.email;
        const validatePhoneNumber = await this.$refs.phoneValidator.validate()

        this.errors.phoneNumber = !validatePhoneNumber.valid

        if (this.newCart.pickUp.type == PiCKUP_TIME.LATER) {
          this.errors.date = !this.newCart.pickUp.date;
          this.errors.time = !this.newCart.pickUp.time;
        } else {
          this.errors.date = null;
          this.errors.time = null;
        }
        if (this.newCart.orderType == ORDER_TYPE.Delivery.id) {
          if (this.newCart.address.id)
            this.errors.address =
              !evaluateValue(this.newCart.address.postcode) ||
              !evaluateValue(this.newCart.address.street_number) ||
              !evaluateValue(this.newCart.address.city) ||
              !evaluateValue(this.newCart.address.region) ||
              !evaluateValue(this.newCart.address.address_line_1);
          else
            this.errors.address =
              !evaluateValue(this.addressToEditData.postcode) ||
              !evaluateValue(this.addressToEditData.street_number) ||
              !evaluateValue(this.addressToEditData.city) ||
              !evaluateValue(this.addressToEditData.region) ||
              !evaluateValue(this.addressToEditData.address_line_1);
        }

        this.errors.table =
          this.newCart.orderType == ORDER_TYPE.Table.id
            ? !evaluateValue(this.table_id)
            : null;

        this.errors.agree = !this.isAgree;
      } else if (this.newCart.step == STEPS.STEP02) {
        this.errors.payment_type = !this.newCart.payment_type;
        if (this.newCart.payment_type == PAYMENT_TYPE.Card) {
          this.errors.payment_mode =
            !evaluateValue(
              this.newCart.user && this.newCart.user.id && this.card_id
            ) && !this.complete;
        } else {
          this.errors.payment_mode = null;
        }
      }

      return Object.keys(this.errors).some((k) => this.errors[k]); // check if any of the element generate an error
    },
    //---- check if the location provide he service delivery to the provided address
    checkTheDeliveryAddess() {
      this.disable = true;
      //---- get the location with the address postcode
      this.fetchLocation({
        id: this.selectedLocation.id,
        postcode: this.newCart.address.postcode,
      })
        .then(() => {
          this.deliverFeeStatus = checkDeliveryAvailibality(
            this.locationStatus.can_make_order,
            this.selectedLocation,
            this.newCart.orderTotal,
            true
          );
          if (this.deliverFeeStatus) {
            if (this.deliverFeeStatus.status) {
              this.newCart.delivery_fee = this.deliverFeeStatus.value;
              cartManager.setCart(this.newCart, true, false);
            }
            this.disable = !this.deliverFeeStatus.status;
          } else {
            //**** TODO : display a popup message */
            showErrorMessageAlert(
              this.$t("message.location_temporary_closed"),
              null,
              "red",
              this.$t("button.ok")
            ).then(() => {
              this.goToHome();
            });
          }
        })
        .catch((e) => {
          this.captureException(e);
          this.deliverFeeStatus = {
            status: false,
            type: "error",
            title: this.$t("validation.valid_address"),
          };
        });
    },
    setTimeOption(date) {
      this.timeOptions = [];
      let currentTime = this.$moment(Date.now());

      let local_date = new Date(date);
      //console.log(local_date);
      //console.log(`${local_date.getDate()}/${local_date.getMonth() + 1}/${local_date.getFullYear()}`);
      let selectedDate_moment = this.$moment(
        `${local_date.getDate()}/${local_date.getMonth() + 1
        }/${local_date.getFullYear()}`,
        "DD/MM/YYYY"
      );
      //console.log(selectedDate_moment);
      let selectedDate = selectedDate_moment.format("YYYY-MM-DD");
      //console.log(selectedDate);
      //console.log(this.laterDateTimeSettings.orderingDates)
      let periods = this.laterDateTimeSettings.orderingDates[selectedDate];

      if (!periods) return [];
      //console.log(periods);

      periods.forEach((item) => {
        //--- create moment date_time fro data manipulation and comparaison
        let dt_OpenAt = this.$moment(
          selectedDate + " " + item.opens_at,
          "YYYY-MM-DD HH:mm"
        );
        let dt_ClosesAt = this.$moment(
          selectedDate + " " + item.closes_at,
          "YYYY-MM-DD HH:mm"
        );

        let periodStart = dt_OpenAt.isSameOrAfter(currentTime)
          ? dt_OpenAt
            .clone()
            .add(this.laterDateTimeSettings.deliveryPickupTime, "minutes")
            .format("HH:mm")
          : currentTime
            .add(this.laterDateTimeSettings.deliveryPickupTime, "minutes")
            .format("HH:mm");

        periodStart = roundTimeQuarterHour(periodStart);

        let periodEnd = dt_ClosesAt.format("HH:mm");

        this.timeOptions = [
          ...this.timeOptions,
          ...getQuarterOrderTimesFromPeriod(
            selectedDate,
            periodStart,
            periodEnd
          ),
        ];
      });
    },
    getOrderSettingsByType() {
      switch (this.newCart.orderType) {
        case ORDER_TYPE.Delivery.id:
          //_ordering_Dates = this.selectedLocation.delivery_time;
          return {
            orderingDates: this.selectedLocation.delivery_time,
            deliveryPickupTime:
              this.selectedLocation.orderSetting.delivery_time,
          };
        case ORDER_TYPE.Collection.id:
          return {
            orderingDates: this.selectedLocation.pickup_time,
            deliveryPickupTime:
              this.selectedLocation.orderSetting.collection_time,
          };
      }
    },
    disabledDatePickerDates(date) {
      if (
        !this.laterDateTimeSettings ||
        !this.laterDateTimeSettings.orderingDates
      )
        return true;
      //8.64e7 : number of milliseconds of a day. We need to subtract the number from current timestamp so that we don't disable today

      if (date.getTime() < Date.now() - 8.64e7) return true;

      let local_date = new Date(date.getTime());
      let currentDay_moment = this.$moment(
        `${local_date.getDate()}/${local_date.getMonth() + 1
        }/${local_date.getFullYear()}`,
        "DD/MM/YYYY"
      );
      let currentDay = currentDay_moment.format("YYYY-MM-DD");

      let arrDays = Object.keys(this.laterDateTimeSettings.orderingDates);
      return !arrDays.includes(currentDay);
    },
    getDateTimeText(pickup) {
      if (pickup.type == PiCKUP_TIME.ASAP)
        return this.$t("text.asap");
      if (!pickup.date || !pickup.time) return "";
      //console.log(pickup)
      return `${this.$t("text.later")} : ${generateFormatedDateTime(
        pickup.date,
        "date",
        "dddd DD MM YYYY",
        this.$i18n.locale
      )} ${generateFormatedDateTime(pickup.time, "time", "HH:mm")}`;
    },
    //*************************** End components Methods ****************************** */

    //*************************** Start Order Tracking Methods ****************************** */
    displayOrderTrack() {
      if (!this.orderCompleted || !this.orderCompleted.newOrder) return null;
      this.loadTracking = true;
      //--- get the order by ID
      this.fetchTrackingOrder({ order_id: this.orderCompleted.newOrder.id })
        .then((response) => {
          this.objOrderHistory = {
            id: response.data.id,
            where2_enabled: response.data.where2_enabled,
            location: response.data.location,
            orderWhere2: response.data.orderWhere2,
            order_type: response.data.order_type,
            order_status: response.data.order_status,
            orderStatusHistory: response.data.orderStatusHistory,
            proposed_ready_time: response.data.proposed_ready_time,
          };
          this.$nextTick(() => {
            this.$refs.itemStatusModal.openModal();
          });
        })
        .finally(() => {
          this.loadTracking = false;
        });
    },
    //*************************** End Order Tracking Methods ****************************** */
    goToHome() {
      this.clearNewCart()
      this.$nextTick(() => {
        router.push("/");
      });
    },

    goToMenu() {
      this.newCart.status = STEP_STATUS.PREPARED;
      this.newCart.newOrder = null;
      this.newCart.id = null;
      this.newCart.step = STEPS.STEP01;
      this.newCart.payment_type = PAYMENT_TYPE.Card;
      this.newCart.pickUp = {
        type: PiCKUP_TIME.ASAP,
        date: null,
        time: null,
      };
      cartManager.setCart(this.newCart, false, false);
      this.$nextTick(() => {
        router.push("/menu");
      });
    },

    redirectToLogin() {
      this.$router.push("/login");
    },
    isCardExpired(cardDetails) {
      if (!cardDetails) {
        return true;
      }
      let expiration = this.$moment(
        `${cardDetails.exp_month}/${cardDetails.exp_year}`,
        "MM/YYYY"
      );
      let now = this.$moment();
      return !now.isSameOrBefore(expiration, "month");
    },
    nativePaymentFailed() {
      this.processing = false;
    },
    checkInputValue(value, errorName)
    {
      this.$set(this.errors, errorName, value && value.length ? null : true)    
    }
  },
  mounted() {

    this.isMounted = true;

    // if the cart is empty redirect the user to home page
    if (localStorage.getItem("saved-order") === "null") {
      if (
        controlAvailibilityBeforeCheckout(
          this.locationStatus, this.newCart
        )
      )
        this.$router.push("/");
    }

    this.newCart.pickUp = {
      type: PiCKUP_TIME.ASAP,
      date: null,
      time: null,
    };
    //--- prepare the interface for the pre-order
    if (
      !this.isLocationEmpty() &&
      this.newCart.orderType != ORDER_TYPE.Table.id
    ) {
      this.laterDateTimeSettings = JSON.parse(
        JSON.stringify(this.getOrderSettingsByType())
      );
      if (
        (this.newCart.orderType == ORDER_TYPE.Delivery.id &&
          !this.locationStatus.openingHours.delivery &&
          this.locationStatus.can_accept_delivery) ||
        (this.newCart.orderType == ORDER_TYPE.Collection.id &&
          !this.locationStatus.openingHours.collection &&
          this.locationStatus.can_accept_collection)
      ) {
        this.newCart.pickUp.type = PiCKUP_TIME.LATER;
      }
    }

    if (this.newCart && this.newCart.orderType == ORDER_TYPE.Table.id)
      this.table_id = this.newCart.table ? this.newCart.table.id : null;

    if (this.newCart && this.newCart.orderType == ORDER_TYPE.Delivery.id) {
      this.address_id =
        this.newCart.address && this.newCart.address.id ? this.newCart.address.id : null;
      if (this.newCart.address && this.newCart.address.postcode)
        this.checkTheDeliveryAddess();
    }

    if (this.isAuthenticated || this.guestData) {
      this.currentUser = this.isAuthenticated ? this.user : this.guestData;
      this.newCart.user = {
        id: this.currentUser.id,
        email: this.currentUser.email,
        first_name: this.currentUser.first_name,
        last_name: this.currentUser.last_name,
        telephone_number: this.currentUser.telephone_number,
      };
    }
  },
  watch: {
    emailExist: {
      handler: function (newVal) {
        this.showEmailAlert = !!newVal;
      },
    },
  },
};
</script>

<style lang="scss">
.k-icon-sadface {
  font-size: 6.5rem;
}

.stripe-card {
  border: 1px solid grey;
}

.stripe-card.complete {
  border-color: green;
}

.pickup-delivery,
.table-ordering,
.mode-payment {
  padding: 0 1.25rem 0.75rem 1.25rem;
}

.pickup-delivery p {
  font-size: 1em;
  margin: 0;
}

.pickup-delivery p.title {
  text-align: left;
  font-weight: 800;
  font-size: 1.1em;
  margin: 0;
  padding: 5px 0 5px 0;
}

.pickup-delivery .list-group-item,
.mode-payment .list-group-item {
  padding: 0;
  border: 0;
}

.pickup-delivery .btn-group,
.pickup-delivery label,
.mode-payment .form-check,
.mode-payment label,
.mode-payment .btn-group {
  width: 100%;
}

.pickup-delivery .form-check {
  padding-left: 0px !important;
}

.datepicker-container {
  padding-top: 1.25rem;
}

.section-steps-1 p {
  font-size: 1em;
}

.section-steps-1 p strong {
  font-weight: 600;
}

.section-steps-1 .p-login {
  font-weight: 600;
  font-size: 0.9em;
}

.stripe-card.form-control {
  border: 1px solid #e3e3e3 !important;
}

.section-steps-2 .stripeImg {
  width: 50%;
  margin: 5px;
  max-width: 170px;
}

.section-steps-2 .apple-pay-img {
  margin-top: 20px;
  max-width: 90px;
}

.section-steps-2 .google-pay-img {
  max-width: 120px;
}

.section-steps-3 {
  padding: 0 20px;
}

.el-select {
  width: 100%;
}

.el-date-table td.disabled div {
  opacity: 0.5 !important;
  filter: alpha(opacity=50) !important;
  /* For IE8 and earlier */
}

.el-date-table td.disabled div span {
  color: #c0c4cc !important;
}

.closed-days span:after {
  font: normal normal normal 12px/1 FontAwesome;
  content: "\F023";
  display: block;
  position: absolute;
  bottom: 6px;
  right: -2px;
}

.grid-payment {
  width: 100%;
  display: grid;
  grid-gap: 8px;
  grid-template-columns: 70% 30%;
}

.grid-payment .grid-label {
  grid-column: 1;
}

.grid-payment .grid-value {
  grid-column: 2;
}

.grid-payment .grid-label,
.grid-payment .grid-value {
  font-size: 1.1rem;
  font-weight: 600;
  text-align: end;
}

.grid-payment .grid-label.green,
.grid-payment .grid-value.green {
  color: #009900;
}

.grid-payment .grid-label.red,
.grid-payment .grid-value.red {
  color: #ff0000;
}

.add-top-margin {
  margin-top: 10px !important;
}

.romove-left-right-padding {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.back-to-menu-link p {
  text-align: center;
}

.clear-selection {
  color: red !important;
  font-weight: 600;
}

.payment-type {
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.2);
  width: 105px;
  height: 100px;
  border-radius: 0.5rem;

  .active {
    font-size: 1.25rem;
  }

  .availale-mode {
    width: 100%;

    .icon {
      .el-image {
        height: 40px;
        margin-top: 10px;
      }

      i {
        font-size: 30px;
      }

      height: 60px;
      display: flex;
      justify-content: center;
      align-content: center;
    }

    .text {
      height: 40px;
      line-height: 40px;
      border-bottom-left-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
      text-align: center;
    }
  }
}

.card-option {
  .card-icon {
    width: 40px;
  }

  .card-text {
    line-height: 40px;
    font-size: 13px;
    text-align: start;
    color: #606266;
  }
}

.card-step1 {
  max-width: 100%;
  margin: 0 auto;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;

  .el-input__prefix {
    .el-input__icon {
      line-height: 40px;
      float: right;
      padding-right: 30px;
    }
  }
}

.card-step2 {
  max-width: 100%;
  margin: 0 auto;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;

  .el-input__prefix {
    width: calc(100% - 40px);
  }

  .form-group .el-select .el-input__inner[readonly] {
    color: #fff !important;
  }
}
</style>
